module.exports = __webpack_public_path__ + "static/media/ArrowBottomBlackSmall.a499049a.svg";